import { Award, Scale, Gem } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const ICONS = [Award, Scale, Gem];

export const Values = ({ t }) => (
  <section
    data-testid="values-section"
    className="relative z-10 py-24 md:py-32 bg-[#0a0a0a] border-y border-white/5"
  >
    <div className="max-w-7xl mx-auto px-6">
      <Reveal>
        <Overline testId="values-overline">{t.values.overline}</Overline>
        <h2 className="font-display text-4xl md:text-5xl tracking-tight max-w-2xl">
          {t.values.title}
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-3 gap-px mt-16 bg-white/10">
        {t.values.items.map((item, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={i} delay={i * 0.12}>
              <div className="group h-full bg-[#0a0a0a] p-10 md:p-12 hover:bg-[#111] transition-colors duration-500">
                <div className="w-14 h-14 flex items-center justify-center border border-[#D4AF37]/40 text-[#D4AF37] mb-8 group-hover:bg-[#D4AF37] group-hover:text-black transition-colors duration-500">
                  <Icon size={24} strokeWidth={1.5} />
                </div>
                <h3 className="font-display text-2xl md:text-3xl mb-4">
                  {item.title}
                </h3>
                <p className="text-white/55 leading-relaxed">{item.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
